<template>
  <div class="sys-users">
    <header class="sys-head">
      <div>
        <div class="sys-title">Системные пользователи</div>
        <div class="sys-sub">Сотрудники с привилегированными ролями</div>
      </div>
      <div class="sys-search">
        <input
          v-model="filter"
          type="text"
          placeholder="Поиск по email / ФИО / телефону"
          class="sys-search-input"
          @input="onFilterChange"
        />
      </div>
    </header>

    <b-card class="sys-table-card" body-class="p-0" no-body>
      <b-table
        :items="loadUsers"
        :fields="fields"
        :busy="isBusy"
        :per-page="perPage"
        :current-page="currentPage"
        responsive
        hover
        striped
        small
        ref="sysTable"
      >
        <template v-slot:cell(rowNumber)="row">{{ (currentPage - 1) * perPage + row.index + 1 }}</template>
        <template v-slot:cell(fullName)="row">
          {{ [row.item.lastName, row.item.firstName, row.item.thirdName].filter(Boolean).join(' ') || '—' }}
        </template>
        <template v-slot:cell(roleName)="row">
          <b-badge variant="primary" pill>{{ row.item.roleName || '—' }}</b-badge>
        </template>
        <template v-slot:cell(isActive)="row">
          <b-badge :variant="row.item.isActive ? 'success' : 'danger'" pill>
            {{ row.item.isActive ? 'Активен' : 'Заблокирован' }}
          </b-badge>
        </template>
        <template v-slot:empty>
          <div class="text-center my-4 text-muted">
            <b-icon icon="people-fill" font-scale="1.5" /><br />
            Системных пользователей нет
          </div>
        </template>
      </b-table>

      <div class="sys-pager" v-if="totalRows > perPage">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
          class="mb-0"
          align="center"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import { apiDomain, getHeader } from '../config/config'

export default {
  name: 'SystemUsers',
  data() {
    return {
      filter: '',
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      isBusy: false,
      fields: [
        { key: 'rowNumber', label: '№', thStyle: { width: '40px' } },
        { key: 'email',     label: 'Email' },
        { key: 'userName',  label: 'Логин' },
        { key: 'fullName',  label: 'ФИО' },
        { key: 'phoneNumber', label: 'Телефон' },
        { key: 'roleName',  label: 'Роль' },
        { key: 'isActive',  label: 'Статус' },
      ],
      _filterTimer: null,
    }
  },
  methods: {
    loadUsers(ctx) {
      this.isBusy = true
      const body = {
        filter:      this.filter || '',
        currentPage: ctx.currentPage || 1,
        perPage:     ctx.perPage || this.perPage,
        audience:    'system',
        isOrg:       -1,
      }
      return axios.post(`${apiDomain}/user/list`, body, { headers: getHeader() })
        .then(res => {
          const r = res.data || {}
          this.totalRows = r.recordCount || 0
          return Array.isArray(r.items) ? r.items : []
        })
        .catch(err => {
          console.error('SystemUsers load:', err)
          return []
        })
        .finally(() => { this.isBusy = false })
    },
    onFilterChange() {
      // Debounce to avoid one request per keystroke.
      clearTimeout(this._filterTimer)
      this._filterTimer = setTimeout(() => {
        this.currentPage = 1
        if (this.$refs.sysTable) this.$refs.sysTable.refresh()
      }, 300)
    },
  },
}
</script>

<style scoped>
.sys-users { padding: 0 4px; }

.sys-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
}
.sys-title {
  font-size: 22px;
  font-weight: 800;
  color: var(--c-text, #0A0A0A);
  letter-spacing: -0.03em;
}
.sys-sub {
  font-size: 12px;
  color: var(--c-muted, #9CA3AF);
  margin-top: 4px;
}
.sys-search-input {
  height: 36px;
  width: min(360px, 60vw);
  padding: 0 12px;
  border: 1px solid var(--c-border, #EAECF0);
  border-radius: 8px;
  background: #fff;
  font-size: 13px;
  outline: none;
}
.sys-search-input:focus {
  border-color: var(--c-accent, #16A37F);
  box-shadow: 0 0 0 3px rgba(22, 163, 127, 0.08);
}

.sys-table-card {
  border: 1px solid var(--c-border, #EAECF0);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
}
.sys-pager {
  padding: 10px 16px;
  border-top: 1px solid var(--c-divider, #F0F2F5);
}
</style>
